import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import ProductTable from '../components/ProductTable'
import { useDispatch } from 'react-redux'
import { fetchLoginUrl } from '../redux/slices/loginSlice'
import Layout from '../layout/Layout'

export default function WholesaleScanner() {
  let dispatch = useDispatch()
  let { listId, favoriteId } = useParams()

  useEffect(() => {
    dispatch(fetchLoginUrl())
  }, [])

  return (
    <Layout scrollWithHeader>
      <ProductTable listId={listId} favoriteId={favoriteId} />
    </Layout>
  )
}
